import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "KY_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { clipPath: "url(#KY_svg__clip0_4799_266067)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "KY_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#KY_svg__b)" }, /* @__PURE__ */ e.createElement("path", { fill: "#2B409A", d: "M0 0h18v14H0z" }), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "KY_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 18,
      height: 14
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h18v14H0z" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#KY_svg__c)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-2.006 13l3.961 1.737L18.088 1.89l2.09-2.582-4.236-.58-6.58 5.537-5.297 3.73L-2.005 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-1.463 14.216l2.018 1.009L19.428-.933h-2.833l-18.058 15.15z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.004 13l-3.961 1.737L-.09 1.89-2.18-.693l4.236-.58 6.58 5.537 5.297 3.73L20.003 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.87 13.874l-2.019 1.008-8.036-6.918-2.383-.773L-2.38-.684H.453l9.807 7.688 2.605.927 7.004 5.943z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "KY_svg__d",
      maskUnits: "userSpaceOnUse",
      x: -2,
      y: -2,
      width: 22,
      height: 18,
      fill: "#000"
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M-2-2h22v18H-2z" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.985 0v-1.5h-1.5V0h1.5zm2 0h1.5v-1.5h-1.5V0zm-2 6v1.5h1.5V6h-1.5zM0 6V4.5h-1.5V6H0zm0 2h-1.5v1.5H0V8zm7.985 0h1.5V6.5h-1.5V8zm0 6h-1.5v1.5h1.5V14zm2 0v1.5h1.5V14h-1.5zm0-6V6.5h-1.5V8h1.5zM18 8v1.5h1.5V8H18zm0-2h1.5V4.5H18V6zM9.985 6h-1.5v1.5h1.5V6zm-2-4.5h2v-3h-2v3zm1.5 4.5V0h-3v6h3zM0 7.5h7.985v-3H0v3zm1.5.5V6h-3v2h3zm6.485-1.5H0v3h7.985v-3zm1.5 7.5V8h-3v6h3zm.5-1.5h-2v3h2v-3zM8.485 8v6h3V8h-3zM18 6.5H9.985v3H18v-3zM16.5 6v2h3V6h-3zM9.985 7.5H18v-3H9.985v3zM8.485 0v6h3V0h-3z",
      fill: "#F7FCFF",
      mask: "url(#KY_svg__d)"
    }
  )), /* @__PURE__ */ e.createElement("g", { clipPath: "url(#KY_svg__clip1_4799_266067)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M21.058 14.722V11.05h7.802V14.722c0 2.352-.909 3.91-1.835 4.88a6.284 6.284 0 01-1.292 1.04c-.18.108-.334.186-.447.237a1.877 1.877 0 01-.186.07 4.953 4.953 0 01-.675-.309 6.754 6.754 0 01-1.39-1.04c-.997-.97-1.977-2.527-1.977-4.878z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M21.058 14.722V11.05h7.802V14.722c0 2.352-.909 3.91-1.835 4.88a6.284 6.284 0 01-1.292 1.04c-.18.108-.334.186-.447.237a1.877 1.877 0 01-.186.07 4.953 4.953 0 01-.675-.309 6.754 6.754 0 01-1.39-1.04c-.997-.97-1.977-2.527-1.977-4.878z",
      stroke: "#0B50A0",
      strokeWidth: 0.1
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M21.058 14.722V11.05h7.802V14.722c0 2.352-.909 3.91-1.835 4.88a6.284 6.284 0 01-1.292 1.04c-.18.108-.334.186-.447.237a1.877 1.877 0 01-.186.07 4.953 4.953 0 01-.675-.309 6.754 6.754 0 01-1.39-1.04c-.997-.97-1.977-2.527-1.977-4.878z",
      stroke: "#F7FCFF",
      strokeWidth: 0.1
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "KY_svg__e",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 21,
      y: 11,
      width: 8,
      height: 10
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M21.058 14.722V11.05h7.802V14.722c0 2.352-.909 3.91-1.835 4.88a6.284 6.284 0 01-1.292 1.04c-.18.108-.334.186-.447.237a1.877 1.877 0 01-.186.07 4.953 4.953 0 01-.675-.309 6.754 6.754 0 01-1.39-1.04c-.997-.97-1.977-2.527-1.977-4.878z",
        fill: "#fff"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M21.058 14.722V11.05h7.802V14.722c0 2.352-.909 3.91-1.835 4.88a6.284 6.284 0 01-1.292 1.04c-.18.108-.334.186-.447.237a1.877 1.877 0 01-.186.07 4.953 4.953 0 01-.675-.309 6.754 6.754 0 01-1.39-1.04c-.997-.97-1.977-2.527-1.977-4.878z",
        stroke: "#fff",
        strokeWidth: 0.1
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#KY_svg__e)" }, /* @__PURE__ */ e.createElement("path", { fill: "#F50100", d: "M20.5 10.5h9v3.4h-9z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M24.512 14.6c.288 0 .864-.314 1.008-.386.528-.314.912-.024 1.224.12.336.145.96.314 1.344 0 .384-.313.6-.289.864-.289.048-.362.048-.723.048-1.133v-.29c-.336-.072-.504.024-.864.338-.36.313-.768.241-1.296.048-.504-.217-1.008-.603-1.512 0-.144.169-.48.41-.816.41-.36 0-.672-.241-.816-.41-.528-.603-1.008-.217-1.512 0-.528.193-.96.265-1.32-.048-.336-.314-.504-.41-.864-.338v.29c0 .41.024.771.072 1.133.264 0 .456-.024.84.29.384.313 1.032.144 1.344 0 .336-.145.72-.435 1.248-.121.144.072.696.386 1.008.386z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.084 12.049s.217.01.474.275 1.202.097 1.202-.063-.574-.256-.353-.53c.22-.273.593-.273.893-.13.087 0 .077.935.273.883.622-.162 1.625-.485 1.92-.346.387.182.683.136.584-.125-.098-.26-.35-.424-.838-.281-.487.142-.372.281-.793.281-.42 0-1.143.228-.822-.281.287-.457.63-.466.76-.274.068.098-.478.315-.478.416 0 .14 1.406-.274 1.586-.274.18 0 .677-.01.726.132.05.142.349.273.12.406-.228.133-.605.216-.345.386.259.17.915.247.944.424.028.177.31.442.197.442-.113 0-.318.25-.508.173-.191-.076-.213-.142-.03-.204.182-.061.18-.32.03-.32-.151 0-.138-.02-.482-.11-.343-.09-.797-.191-.77 0 .027.191.26.602-.153.64-.412.04-.605.197-.686.07-.08-.126-.367-.294-.141-.349.225-.054.441.184.522.145.082-.039.257-.177.103-.342-.155-.164-.454-.17-.218-.293.235-.123.095-.217-.355.038-.45.255-.7.472-1.094.442-.394-.031-.571.11-.698.068-.127-.042-.744.457-.922.33-.178-.126-.752-.175-.648-.33.103-.156.242-.236.396-.156.155.08.308.16.412.08.105-.08.435-.453.36-.508-.077-.055-.343-.15-.772-.15-.428 0-.438-.284-.54-.414-.102-.13.144-.151.144-.151z",
      fill: "#FFD100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M24.512 17c.288 0 .864-.314 1.008-.386.528-.313.912-.024 1.224.12.336.145.96.314 1.344 0 .384-.313.6-.289.864-.289.048-.361.048-.723.048-1.133v-.29c-.336-.072-.504.025-.864.338-.36.314-.768.242-1.296.049-.504-.217-1.008-.603-1.512 0-.144.168-.48.41-.816.41-.36 0-.672-.242-.816-.41-.528-.603-1.008-.217-1.512 0-.528.192-.96.265-1.32-.049-.336-.313-.504-.41-.864-.337v.29c0 .41.024.77.072 1.132.264 0 .456-.024.84.29.384.313 1.032.144 1.344 0 .336-.145.72-.434 1.248-.12.144.072.696.385 1.008.385zM24.512 19.3c.288 0 .864-.314 1.008-.386.528-.313.912-.024 1.224.12.336.145.96.314 1.344 0 .384-.313.6-.289.864-.289.048-.361.048-.723.048-1.133v-.29c-.336-.072-.504.025-.864.338-.36.314-.768.241-1.296.048-.504-.217-1.008-.602-1.512 0-.144.17-.48.41-.816.41-.36 0-.672-.24-.816-.41-.528-.602-1.008-.217-1.512 0-.528.193-.96.266-1.32-.048-.336-.313-.504-.41-.864-.337v.289c0 .41.024.772.072 1.133.264 0 .456-.024.84.29.384.313 1.032.144 1.344 0 .336-.145.72-.434 1.248-.121.144.072.696.386 1.008.386zM24.512 21.6c.288 0 .864-.314 1.008-.386.528-.314.912-.024 1.224.12.336.145.96.314 1.344 0 .384-.313.6-.289.864-.289.048-.362.048-.723.048-1.133v-.29c-.336-.072-.504.024-.864.338-.36.313-.768.241-1.296.048-.504-.217-1.008-.603-1.512 0-.144.169-.48.41-.816.41-.36 0-.672-.241-.816-.41-.528-.603-1.008-.217-1.512 0-.528.193-.96.265-1.32-.048-.336-.314-.504-.41-.864-.338v.29c0 .41.024.771.072 1.133.264 0 .456-.024.84.29.384.313 1.032.144 1.344 0 .336-.145.72-.435 1.248-.121.144.072.696.386 1.008.386z",
      fill: "#0B50A0"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M25.082 18.544l-.05-.026-.047.029-.417.247.122-.517.014-.057-.043-.04-.405-.374h.589l.024-.066.173-.47.206.476.026.06h.494l-.36.38-.04.043.018.057.17.509-.474-.25zM23.082 16.544l-.05-.026-.047.029-.417.247.122-.517.014-.057-.043-.04-.405-.374h.589l.024-.066.173-.47.206.476.026.06h.494l-.36.38-.04.043.018.057.17.509-.474-.25zM27.082 16.544l-.05-.026-.047.029-.417.247.122-.517.014-.057-.043-.04-.405-.374h.589l.024-.066.173-.47.206.476.026.06h.494l-.36.38-.04.043.018.057.17.509-.474-.25z",
      fill: "#059334",
      stroke: "#FFD100",
      strokeWidth: 0.2
    }
  ))), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.337 20.634c.092.197.75.455 1.515.123.521-.233.858-.565 1.18-1.155.091-.148.137-.332-.077-.442-.168-.099-.444-.21-.567-.308-.06-.049-.122-.086-.168-.122.03.024.061.049.092.085.306.295-.015.726-.352.984-.245.184-.69.639-1.332.209-.138-.099-.46.307-.291.626zM29.645 20.634c-.107.197-.766.455-1.516.123-.52-.233-.857-.565-1.194-1.155-.077-.148-.122-.332.092-.442.168-.099.444-.21.566-.308.062-.049.108-.086.169-.122-.03.024-.061.049-.092.085-.306.295.015.726.337.984.245.184.704.639 1.347.209.138-.099.444.307.291.626z",
      fill: "#FFD100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M24.992 21.692c1.225 0 3.108-.443 4.119-1.991.168-.258 0-.393-.2-.48a2.384 2.384 0 01-.612-.356c.245.197.2.332.03.553-.78 1.045-1.852 1.573-3.337 1.573s-2.557-.528-3.338-1.573c-.168-.221-.214-.356.016-.553-.123.11-.399.283-.613.357-.199.086-.367.22-.199.479 1.01 1.548 2.91 1.99 4.134 1.99z",
      fill: "#FFD100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M22.159 19.615c-.031-.123-.23-.074-.291.073-.077-.086-.153-.172-.215-.27-.183-.221-.214-.369.046-.578.123-.098.368-.208.536-.085.352.233.169.614-.076.86zM27.809 19.615c.03-.123.245-.074.306.073.076-.086.153-.172.214-.27.184-.221.215-.369-.061-.578-.107-.098-.352-.208-.536-.085-.337.233-.168.614.077.86z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M23.424 9.365c-.12-.165-.447-.238-.584-.091-.052.036-.12.036-.172.054-.086 0-.196.046-.162.229.093 0 .093.045.145.045.034-.018.123.317.295.298.19 0 .358.085.392.122.052.055.12.2.034.274a.385.385 0 000 .566c.224.182.791.456 1.427-.073.619-.512 1.581-.22 1.65-.037.086.183.12.292.138.383.017.073.48.183.55.238.086.054.206.036.172-.128-.07-.511-.361-.584-.396-.821.172.018.292.018.361-.055.052-.073.12-.201.19-.238.05-.036.05-.073-.018-.054-.086.018-.137.054-.292.036-.366-.042-.276-1.427-1.486-1.696-.748-.167-1.68.975-1.936 1.088a.13.13 0 01-.016.006.36.36 0 01-.292-.146z",
      fill: "#059334"
    }
  ))),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "KY_svg__clip0_4799_266067" }, /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })), /* @__PURE__ */ e.createElement("clipPath", { id: "KY_svg__clip1_4799_266067" }, /* @__PURE__ */ e.createElement("path", { fill: "#fff", transform: "translate(21 11)", d: "M0 0h8v10H0z" })))
), a = t;
export {
  a as default
};
